import { Button, ButtonProps, Flex, Space, Typography } from "antd";
import {
  formatTime,
  MAX_SAMPLE_DURATION,
} from "../../../hooks/useVoiceCloning";

export const RecordControl = ({
  stopDisabled,
  handleMicButtonClick,
  icon,
  showDuration,
  recordingDuration,
  ...buttonProps
}: {
  stopDisabled: boolean;
  handleMicButtonClick: () => void;
  icon: React.ReactNode;
  showDuration: boolean;
  recordingDuration: number;
} & ButtonProps) => {
  return (
    <Flex
      vertical
      gap={10}
      style={{ width: "100%" }}
      align="center"
      justify="center"
    >
      <Button
        shape="circle"
        type="primary"
        style={{
          alignItems: "center",
          display: "flex",
          width: 70,
          height: 70,
        }}
        disabled={stopDisabled}
        onClick={handleMicButtonClick}
        {...buttonProps}
      >
        {icon}
      </Button>
      {showDuration && (
        <Space>
          <DurationCounter recordingDuration={recordingDuration} />
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            /
          </Typography.Text>
          <DurationCounter recordingDuration={MAX_SAMPLE_DURATION} />
        </Space>
      )}
    </Flex>
  );
};

const DurationCounter = ({
  recordingDuration,
}: {
  recordingDuration: number;
}) => {
  return (
    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
      {formatTime(recordingDuration)}
    </Typography.Text>
  );
};
